var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA2H(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 66",
    height: 249.449,
    width: 207.874,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58.808h47.348v32.818H4.58z",
    fill: "#fff",
    fillOpacity: 1,
    stroke: "#0148b2",
    strokeWidth: 4.086,
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0148b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.77 20.616h20.054v43.32H2.689v-43.32h20.055",
    strokeWidth: 1.864
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.997 4.048l-.31 36.451",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#A)",
    transform: "matrix(.520728 0 0 .460133 13.55049 -.312764)",
    d: "M46.004 37.78l-18.026.202-18.026.202 8.838-15.712L27.628 6.76l9.188 15.51z",
    strokeWidth: 4.086
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2H);
export default __webpack_public_path__ + "static/media/a2h.c8fb2ce1922dc3c7d8344a9e9f85afd8.svg";
export { ForwardRef as ReactComponent };